var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { resets } from "@recoil/Store";
import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import { PromiseHttp } from "@utils/api/HttpUtil";
import * as Const from "@utils/Const";
export default function MenuCreate(props) {
    const { item, setItem } = props;
    const setReset = useSetRecoilState(resets);
    const [name, setName] = useState("");
    const [url, setUrl] = useState("");
    const [isActive, setIsActive] = useState(false);
    let lang = localStorage.getItem(Const.LANG_TYPEA);
    let token = localStorage.getItem(Const.TOKEN);
    const handleView = (type) => {
        setItem(Object.assign(Object.assign({}, item), { type: type }));
    };
    const MenuAdd = (e) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        var isOk = confirm(`해당 메뉴를 등록하시겠습니까?`);
        if (!isOk)
            return;
        let appPath = Object.assign({ name: name, url: url, isActive: isActive, lang: lang, "depth": ((_a = item.depth1) === null || _a === void 0 ? void 0 : _a.menuId) ? 2 : 1 }, (((_b = item.depth1) === null || _b === void 0 ? void 0 : _b.menuId) && { parentId: item.depth1.menuId }));
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_POST,
            appPath: `/admin/menu`,
            appQuery: appPath,
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                alert("등록되었습니다.");
                location.reload();
            }
            else {
                alert(data.body.message);
            }
        }
    });
    return (_jsx(_Fragment, { children: _jsxs("section", Object.assign({ className: "board-main" }, { children: [_jsx("h2", { children: "\uBA54\uB274 \uCD94\uAC00" }), item.depth1 &&
                    _jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC0C1\uC704ID" }), _jsx("input", { type: "text", disabled: true, value: item.depth1.menuId })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uC0C1\uC704 \uBA54\uB274" }), _jsx("input", { type: "text", disabled: true, value: item.depth1.menuName })] }))] }), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "\uBA54\uB274\uBA85" }), _jsx("input", { type: "text", value: name, onChange: (e) => setName(e.target.value) })] })), _jsxs("div", Object.assign({ className: "form-row" }, { children: [_jsx("label", { children: "URL" }), _jsx("input", { type: "text", value: url, onChange: (e) => setUrl(e.target.value) })] })), _jsxs("div", Object.assign({ className: "footer-row" }, { children: [_jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "active", checked: isActive, onChange: (e) => setIsActive(e.target.checked) }), " \uBA54\uB274 \uD65C\uC131\uD654"] }), _jsxs("div", Object.assign({ className: "btn-group" }, { children: [_jsx("button", Object.assign({ className: "edit-btn", onClick: (e) => MenuAdd(e) }, { children: "\uC800\uC7A5" })), _jsx("button", Object.assign({ className: "delete-btn", onClick: () => handleView(Const.TYPE_V) }, { children: "\uCDE8\uC18C" }))] }))] }))] })) }));
}
